package ui

import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.unit.*
import io.*
import provider.*
import theme.*
import tk.mallumo.compose.navigation.*


private val windowProvider = WindowProvider()
val snackBarStateGlobal = SnackbarHostState()

@Composable
@ComposableNavNode
fun EmptyUI() = Unit

@Composable
fun LauncherUI(args: ArgsInitial) {
    val acc = LocalAccountProvider.current
    val initialAcc = remember {
        acc.current
    }

    Repository.setup()
    val homeDrawerProvider = HomeDrawerProvider.remember()
    AppTheme {
        Box(modifier = Modifier.fillMaxSize()) {
            CompositionLocalProvider(
                LocalWindowProvider provides windowProvider,
                LocalHomeDrawerProvider provides homeDrawerProvider,
                LocalScrollbarStyle provides ScrollbarStyle(
                    minimalHeight = 16.dp,
                    thickness = 8.dp,
                    shape = RoundedCornerShape(4.dp),
                    hoverDurationMillis = 300,
                    unhoverColor = MaterialTheme.colorScheme.onBackground.copy(alpha = 0.25f),
                    hoverColor = MaterialTheme.colorScheme.onBackground.copy(alpha = 0.50f)
                )
            ) {
                Scaffold(snackbarHost = { SnackbarHost(snackBarStateGlobal) }) {
                    Box {
                        if (initialAcc == null) {
                            NavigationRoot(Node.LoginUI, args.asBundle())
                        } else {
                            NavigationRoot(Node.HomeUI, args.asBundle())
                        }
                        windowProvider.attachToWindow()
                    }
                }

            }
        }
    }
}
